module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('picture', [_c('source', {
    attrs: {
      "srcset": _vm.sourceSrcset
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "srcset": _vm.imgSrcset,
      "alt": _vm.alt
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1487334","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/Picture.vue
// module id = 546
// module chunks = 2